import baseApi from "@/api/baseApi";

const api = {
  async getComplaints(data: any) {
    const response = await baseApi({
      method: "post",
      url: `/complaints`,
      data: data,
    });

    return response.data;
  },

  async getComplaintsCount(data: any) {
    const response = await baseApi({
      method: "post",
      url: `/complaints/count`,
      data: data,
    });

    return response.data;
  },

  async getComplaintsFilteroptions() {
    const response = await baseApi({
      method: "get",
      url: `/complaints/filteroptions`,
      data: { hideLoader: true },
    });

    return response.data;
  },

  async getComplaintDetails(regLineId: number) {
    const response = await baseApi({
      method: "get",
      url: `/complaints/${regLineId}`,
      data: { hideLoader: true },
    });

    return response.data;
  },
  async updateComplaint(regLine: any) {
    const response = await baseApi({
      method: "post",
      url: `/complaints/update`,
      data: regLine,
    });

    return response.data;
  },

  async createFromChecklistItem(data: any) {
    const response = await baseApi({
      method: "post",
      url: `/complaints/createfromchecklistitem`,
      data: data,
    });

    return response.data;
  },
};

export default api;
